import React from 'react';
import "./ServicesLoader.css"

const ServicesLoader = () => {

    return (
        <div className="services-loader-contaioner">
            <div className="services-loader"></div>
            <div className="services-loader"></div>
            <div className="services-loader"></div>

        </div>
    );
};

export default ServicesLoader;
